import {Code} from "@/v2/i18n/modules/zhCN/status/code";

export const Status = {

    code: Code

}